import React from 'react'
import { Info, AlertTriangle, X } from 'lucide-react'

export function DemoModeBanner() {
  const [dismissed, setDismissed] = React.useState(false)
  const isDemoMode = localStorage.getItem('demo_mode') === 'true'

  // Only show on demo family
  if (!isDemoMode || dismissed) {
    return null
  }

  return (
    <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border-b-2 border-yellow-200 px-4 py-2 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3 flex-1">
          <Info className="w-5 h-5 text-yellow-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-medium text-yellow-900">
              <strong>Demo Mode</strong> - You're exploring a shared demo environment
            </p>
            <p className="text-xs text-yellow-800 mt-0.5">
              Data resets nightly. Some features are view-only to preserve the demo for others.
            </p>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-yellow-100 rounded transition-colors ml-4"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4 text-yellow-700" />
        </button>
      </div>
    </div>
  )
}

export function DemoRestrictionWarning({ action }: { action: string }) {
  const isDemoMode = localStorage.getItem('demo_mode') === 'true'

  if (!isDemoMode) {
    return null
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 flex items-start space-x-2 mb-4">
      <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-yellow-800">
        <strong>Demo Mode:</strong> {action} This change will show what would happen, but won't be saved to preserve the demo for other users.
      </div>
    </div>
  )
}

// Hook to check if we're in demo mode
export function useDemoMode() {
  const isDemoMode = localStorage.getItem('demo_mode') === 'true'
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const isDemo = hostname.includes('demo.housepoints.ai') || isDemoMode

  return {
    isDemoMode: isDemo,
    showWarning: (action: string) => {
      if (isDemo) {
        return `Demo Mode: ${action} (changes not saved)`
      }
      return null
    }
  }
}
